package fr.manyverse.app.presentation.components.notification

sealed class NotificationContent {
    abstract val id: String

    data class DiceRoll(
        override val id: String,
        val characterName: String,
        val dieType: String,
        val count: Int,
        val results: List<Int>,
        val criticalMin: Int?,
        val criticalMax: Int?,
        val modifier: Int = 0,
        val highValuesWin: Boolean = true
    ) : NotificationContent()

    data class NewMessage(
        override val id: String,
        val senderName: String,
        val text: String,
        /** Conversation à ouvrir quand on appuie sur la notification. */
        val conversationKey: String
    ) : NotificationContent()

    data class PlayerJoined(
        override val id: String,
        val characterName: String
    ) : NotificationContent()

    data class ItemReceived(
        override val id: String,
        /** Nom du personnage expéditeur, ou null quand l'objet vient du MJ. */
        val senderName: String?
    ) : NotificationContent()
}
